var _ref2, _ref3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOccupation = function SvgOccupation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.98926 14.5C4.89935 14.5 4 15.3994 4 16.4893V17.25C4 19.0521 5.13963 20.4461 6.65332 21.2812C8.16701 22.1164 10.0841 22.5 12 22.5C13.9159 22.5 15.833 22.1164 17.3467 21.2812C18.8604 20.4461 20 19.0521 20 17.25V16.4893C20 15.3994 19.1006 14.5 18.0107 14.5H5.98926ZM5.98926 16H10.8457L11.5713 17.5713L10.2529 20.8682C9.17347 20.7078 8.16702 20.4041 7.37793 19.9688C6.17287 19.3039 5.5 18.4479 5.5 17.25V16.4893C5.5 16.2102 5.71016 16 5.98926 16ZM18.0107 16H13.1543L12.4287 17.5713L13.7471 20.8682C14.8265 20.7078 15.833 20.4041 16.6221 19.9688C17.8271 19.3039 18.5 18.4479 18.5 17.25V16.4893C18.5 16.2102 18.2898 16 18.0107 16Z",
      fill: "#041F47"
    })), _ref3 || (_ref3 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2.75C9.65279 2.75 7.75 4.65279 7.75 7C7.75 9.34721 9.65279 11.25 12 11.25C14.3472 11.25 16.25 9.34721 16.25 7C16.25 4.65279 14.3472 2.75 12 2.75ZM6.25 7C6.25 3.82436 8.82436 1.25 12 1.25C15.1756 1.25 17.75 3.82436 17.75 7C17.75 10.1756 15.1756 12.75 12 12.75C8.82436 12.75 6.25 10.1756 6.25 7Z",
      fill: "#041F47"
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgOccupation, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/occupation.c102692e.svg";
export { ForwardRef as ReactComponent };